import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import { Carousel as AntdCarousel } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import SliderButton from './slider-button';

const buttonStyle = css`
  width: 10px !important;
  height: 10px !important;
  border-radius: 10px !important;
  background: ${p => p.theme.colors.darkTheme} !important;
`;

const DraaiMolen = styled(AntdCarousel)`
  .slick-dots {
    display: flex !important;
    justify-content: center;
    align-items: center;
    position: static !important;
    padding: 14px 0 !important;
    width: 10px !important;
    height: 10px !important;
    margin: 0 auto;
  }
  ${p => p.itemsToHighlight && p.itemsToHighlight?.map(n =>
  `.slick-dots li:nth-child(${n.index + 1}) {
      border: 1px solid rgb(0, 120, 161);
      border-radius: 19px;
      width: 10px !important;
      height: 10px !important;
    }`,
)}
  .slick-list {
    margin-bottom: 5px !important;
    margin-left: 2px;
  }
  .slick-dots li button {
    ${buttonStyle};
  }
  .slick-dots li {
    width: 10px;
    height: 10px;
  }
  .slick-dots li.slick-active button {
    ${buttonStyle};
  }
`;

const Carousel = ({ initialSlide = 0, children, itemsToHighlight }) =>
  <DraaiMolen
    dots={true}
    arrows={true}
    prevArrow={<SliderButton icon={<LeftOutlined />} right={false} />}
    nextArrow={<SliderButton icon={<RightOutlined />} right={true} />}
    initialSlide={initialSlide}
    itemsToHighlight={itemsToHighlight}
  >
    {children}
  </DraaiMolen>;
Carousel.propTypes = {
  children: PropTypes.node,
  initialSlide: PropTypes.number,
  itemsToHighlight: PropTypes.array,
};

export default Carousel;
